import styled from 'styled-components';
import { screenSmMin } from '@spotify-internal/encore-foundation';
import { Type } from '@spotify-internal/encore-web';
export const Wrapper = styled.header `
  font-family: spotify-circular, Circular, Helvetica, Arial, sans-serif;
  text-align: ${({ textAlign }) => textAlign};
  line-height: 1.5;

  ${({ disableEndMargin }) => !disableEndMargin &&
    `
    margin-bottom: 30px;

    @media (min-width: ${screenSmMin}) {
      margin-bottom: 72px;
    }
  `};
`;
export const Title = styled(Type.h1) `
  margin-block-start: 0;
  margin-block-end: 0;
  font-size: 32px;
  line-height: 1.3;
  letter-spacing: -0.015em;
  font-weight: 900;
  padding: 0;

  @media (min-width: ${screenSmMin}) {
    font-size: 48px;
  }
`;
export const Supheader = styled(Type.h3) `
  margin-bottom: 20px;
`;
export const Subheader = styled(Type.h2) `
  font-weight: normal;
  font-size: 13px;
  margin-top: 10px;
  padding: 0;

  @media (min-width: ${screenSmMin}) {
    font-size: 20px;
    margin-top: 15px;
  }
`;
//# sourceMappingURL=components.js.map